export default __webpack_public_path__ + "static/media/cookies.d8f00d16.png";